<script>
export default {
  name: "AppProjects",
  mounted() {
    this.$nextTick(() => {
      // Ajoute un écouteur d'événements pour le défilement
      window.addEventListener("scroll", this.handleScroll);

      // Ajoute un écouteur d'événements pour chaque projet
      document.querySelectorAll('.project').forEach(project => {
        project.addEventListener('click', this.handleProjectClick);
      });
    });
  },
  beforeUnmount() {
    // Nettoie les écouteurs d'événements lors de la destruction du composant
    window.removeEventListener("scroll", this.handleScroll);
    document.querySelectorAll('.project').forEach(project => {
      project.removeEventListener('click', this.handleProjectClick);
    });
  },
  methods: {
    handleScroll() {
      // Effet scroll des projets
      const project = document.querySelector(".project");

      if (project) {
        const projectTop = project.getBoundingClientRect().top;
        const projectBottom = project.getBoundingClientRect().bottom;
        const windowHeight = window.innerHeight;

        // Active le texte défilant si le projet est visible
        if (projectTop < windowHeight && projectBottom > 0) {
          project.classList.add("scrolling-visible");
        } else {
          project.classList.remove("scrolling-visible");
        }
      }
    },
    handleProjectClick(e) {
      // Vérifie si l'utilisateur a cliqué sur un lien interne
      if (e.target.closest('a')) return;

      // Récupère l'URL à partir de l'attribut data-url
      const project = e.currentTarget;
      const url = project.getAttribute('data-url');

      // Redirige vers l'URL correspondante
      if (url) {
        if (url.startsWith('/')) {
          this.$router.push(url).catch(err => console.error("Router error:", err));
        } else {
          window.open(url, '_blank');
        }
      } else {
        console.warn("No data-url found on project");
      }
    }
  }
};

</script>

<template>
  <section id="projets">
    <h3 class="slide-reveal">MES PROJETS</h3>
    <div class="projects">
      <div class="project" data-url="/rlts">
        <div class="scroll-text-ctn" style="--quantity: 2">
          <span class="scroll-text" style="--position: 1">ROCKET LEAGUE TOP SCORER</span>
          <span class="scroll-text" style="--position: 2">ROCKET LEAGUE TOP SCORER</span>
        </div>
        <div class="project-infos">
          <h3>ROCKET LEAGUE TOP SCORER</h3>
          <h4>Mission Freelance - KNY PRODUCTION</h4>
          <div class="tech">
            <img class="bg-white" src="@/assets/images/logo/html-css-js.png" alt="html/css/js">
            <img src="@/assets/images/logo/python.png" alt="python">
            <a href="https://flask.palletsprojects.com/en/stable/" target="_blank">
              <img class="bg-white" src="@/assets/images/logo/flask.png" alt="flask python">
            </a>
            <a href="https://discordpy.readthedocs.io/en/stable/" target="_blank">
              <img class="radius" src="@/assets/images/logo/discord-py.png" alt="discord.py">
            </a>
          </div>
        </div>
        <img class="project-img" alt="Rocket League Top Scorer" src="@/assets/images/rlts.png" />
      </div>
      <div class="project" data-url="https://pacificaband.fr">
        <div class="scroll-text-ctn" style="--quantity: 3">
          <span class="scroll-text" style="--position: 1">PACIFICA FANSITE</span>
          <span class="scroll-text" style="--position: 2">PACIFICA FANSITE</span>
          <span class="scroll-text" style="--position: 3">PACIFICA FANSITE</span>
        </div>
        <div class="project-infos">
          <h3>PACIFICA FANSITE</h3>
          <h4>Projet personnel</h4>
          <div class="tech">
            <img class="bg-white" src="@/assets/images/logo/html-css-js.png" alt="html/css/js">
            <a href="https://gsap.com/" target="_blank">
              <img class="radius" src="@/assets/images/logo/gsap.png" alt="gsap">
            </a>
          </div>
        </div>
        <img class="project-img" alt="Pacfica Fansite" src="@/assets/images/pacifica-fansite.png" />
      </div>
      <div class="project" data-url="https://lagrangealegumesbio.fr">
        <div class="scroll-text-ctn" style="--quantity: 2">
          <span class="scroll-text" style="--position: 1">LA GRANGE À LÉGUMES BIO</span>
          <span class="scroll-text" style="--position: 2">LA GRANGE À LÉGUMES BIO</span>
        </div>
        <div class="project-infos">
          <h3>LA GRANGE À LÉGUMES BIO</h3>
          <h4>Stage - La Grange à Légumes BIO</h4>
          <div class="tech">
            <img class="bg-white" src="@/assets/images/logo/html-css-js.png" alt="html/css/js">
            <img class="bg-white" src="@/assets/images/logo/laravel.png" alt="laravel">
            <img src="@/assets/images/logo/php.png" alt="php">
          </div>
        </div>
        <img class="project-img" alt="La Grange à Légumes BIO" src="@/assets/images/lgalb.png" />
      </div>
      <div class="project" data-url="https://kgg-foxhole.fr">
        <div class="scroll-text-ctn" style="--quantity: 3">
          <span class="scroll-text" style="--position: 1">KGG - FOXHOLE</span>
          <span class="scroll-text" style="--position: 2">KGG - FOXHOLE</span>
          <span class="scroll-text" style="--position: 3">KGG - FOXHOLE</span>
        </div>
        <div class="project-infos">
          <h3>KGG - FOXHOLE</h3>
          <h4>Projet personnel réalisé avec une designeuse</h4>
          <div class="tech">
            <img class="bg-white" src="@/assets/images/logo/html-css-js.png" alt="html/css/js">
            <a href="https://gsap.com/" target="_blank">
              <img class="radius" src="@/assets/images/logo/gsap.png" alt="gsap">
            </a>
            <img src="@/assets/images/logo/php.png" alt="php">
          </div>
        </div>
        <img class="project-img" alt="KGG-Foxhole" src="@/assets/images/kgg-foxhole.png" />
      </div>
    </div>
  </section>
</template>

<style>
#projets h3{
  font-family: 'ClashDisplay', sans-serif;
  display: inline-block;
  margin: 0.5em 0 1em 0;
}

.projects {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 2vh;
}

.projects h3{font-family: 'Whyte Inktrap', sans-serif}

.project{
  position: relative;
  z-index: 1;
  margin: 0 10vw;
  padding: 2vh;
  display: flex;
  border-radius: 12px;
  justify-content: space-between;
  align-items: center;
  background: rgba(255,255,255,0.1);
  overflow: hidden;
  transition: 0.4s padding, 0.4s margin;
}

.project:hover{
  margin: 0;
  padding: 2vh 10vw;
  border-radius: 0;
  background: rgba(255,255,255,0.06);
}

.project a{
  pointer-events: none;
}

.project .tech a{
  pointer-events: auto;
}

.scroll-text-ctn{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.scroll-text{
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  font-family: "Galderglynn 1884", sans-serif;
  font-size: 32vh;
  letter-spacing: 2px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.5s ease;
  z-index: 0;
}

.project:hover .scroll-text {
  opacity: 0.1;
  animation: scrollText 9s linear infinite;
  animation-delay: calc( (9s / var(--quantity)) * (var(--position) - 1) );
}

@keyframes scrollText {
  from {
    left: 100%;
  }
  to {
    left: -100%;
  }
}

.project-infos{
  text-align: left;
  z-index: 1;
}

.project-infos h3{
  font-weight: 600;
  margin: 0;
  font-size: 2.8em;
}

.project-infos h4{
  font-weight: 300;
  margin: 0;
  font-size: 2em;
}

.project-img{
  width: 25vw;
  border-radius: 10px;
  z-index: 1;
}

.tech{
  display: flex;
  gap: 10px;
  align-items: center;
}

.tech img{
  height: 32px;
}

.radius{
  border-radius: 50px;
  padding: 2px;
}

.bg-white{
  background-color: white;
  padding: 2px;
  border-radius: 4px;
}

/* RESPONSIVE */

@media (max-width: 768px) {
  .project{
    margin: 0 2.6vw;
  }

  .project:hover{
    padding: 2vh 2.6vw;
  }

  .project-infos h3{
    font-size: 2em;
  }

  .project-infos h4{
    font-size: 1.4em;
  }

  .scroll-text{
    font-size: 42vh;
  }
}

@media (max-width: 480px) {
  #projets h3{
    margin: 0.4em 0;
  }

  .project-infos h3{
    font-size: 1.8em;
  }

  .project-infos h4{
    font-size: 1.2em;
    padding-bottom: 1vh;
  }

  .project-img{
    display: none;
  }
}
</style>